// The "Set this model as default" box on the LLM card, from what is known
// about the existing LLM services.
export interface DefaultModelChoice {
  // Whether the new service gets activated once it exists.
  checked: boolean;
  // The box can't be changed: it is locked off while the list loads (so it
  // doesn't flip under the cursor) and locked on for the first LLM.
  locked: boolean;
  // No LLM exists yet, so the new one is the default by necessity — the
  // engine falls back to the first LLM — and the card says so.
  firstLlm: boolean;
}

// `llmCount` is undefined while the list is unknown: still loading, or the
// query failed. A failed lookup leaves the choice to the user rather than
// activating on its own, since that could silently replace the current
// default.
export function defaultModelChoice(
  llmCount: number | undefined,
  loading: boolean,
  wanted: boolean,
): DefaultModelChoice {
  if (loading) return { checked: false, locked: true, firstLlm: false };
  if (llmCount === 0) return { checked: true, locked: true, firstLlm: true };
  return { checked: wanted, locked: false, firstLlm: false };
}
